// Module
var code = `<tour-step-body><span translate="activity-editor_tour_body"></span></tour-step-body>`;
// Exports
export default code;